import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  L10nTranslationModule,
  L10N_LOCALE,
  L10nLocale,
  L10nTranslationService,
} from 'angular-l10n';
import { DialogModule } from 'primeng/dialog';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { ImprintComponent } from '../imprint/imprint.component';
import { ButtonModule } from 'primeng/button';
import { VERSION } from '../../../../version';

@Component({
  selector: 'supplierDB-registration-footer',
  standalone: true,
  imports: [
    CommonModule,
    DisclaimerComponent,
    ImprintComponent,
    L10nTranslationModule,
    DialogModule,
    ButtonModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  public year!: number;
  public showImprint: boolean = false;
  public showDisclaimer: boolean = false;
  version: string = VERSION.version;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
  ngOnInit() {
    this.year = new Date().getFullYear();
  }
}
